import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationComponent } from './authorization/auth.component';
import { AuthGuard } from './core/services/auth/auth.guard';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';

const routes: Routes = [
  {
    path: '',
    component: AuthorizationComponent,
  },
  {
    path: 'disclaimer',
    component: DisclaimerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'groupdetail',
    loadChildren: () =>
      import('./group-detail/group-detail.module').then(
        (m) => m.GroupDetailModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'plans/:id',
    loadChildren: () =>
      import('./plan-selection/plan-selection.module').then(
        (m) => m.PlanSelectionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'contribution/:id',
    loadChildren: () =>
      import('./contribution/contribution.module').then(
        (m) => m.ContributionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'delivery/:id',
    loadChildren: () =>
      import('./delivery/delivery.module').then((m) => m.DeliveryModule),
    canActivate: [AuthGuard],
  },  
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
  {
    path: '**',
    component: AuthorizationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
